import { useDispatch, useSelector } from "react-redux";
import {
    selectIsUserApprovedTerms,
    selectIsUserApprovedTermsFetched,
} from "app/pages/sales-intelligence/sub-modules/intent/store/management/selectors/selectors";
import { useEffect, useState } from "react";
import {
    fetchIntentManagementApprovalThunk,
    saveIntentManagementApprovalThunk,
} from "app/pages/sales-intelligence/sub-modules/intent/store/management/effects/effects";

const useIntentManagementApprovedAction = () => {
    const dispatch = useDispatch();
    const isUserApprovedTerms = useSelector(selectIsUserApprovedTerms);
    const isUserApprovedTermsFetched = useSelector(selectIsUserApprovedTermsFetched);
    const intentApproval = localStorage.getItem("si:intent-approval");
    const [isOpenAdminApprovalModal, setIsOpenAdminApprovalModal] = useState(false);

    useEffect(() => {
        if (!intentApproval) {
            void dispatch(fetchIntentManagementApprovalThunk());
        }
    }, [intentApproval]);

    useEffect(() => {
        if (!isUserApprovedTermsFetched) {return;}

        if (isUserApprovedTerms) {
            localStorage.setItem("si:intent-approval", "true");
        }
    }, [isUserApprovedTerms, isUserApprovedTermsFetched]);

    const onClickManagementApprovedTerms = () => {
        void dispatch(saveIntentManagementApprovalThunk());
        localStorage.setItem("si:intent-approval", "true");
        setIsOpenAdminApprovalModal(false);
    };

    const onCancelIntentManagementModal = () => {
        setIsOpenAdminApprovalModal(false);
    };

    return {
        isOpenAdminApprovalModal,
        onClickManagementApprovedTerms,
        onCancelIntentManagementModal,
        setIsOpenAdminApprovalModal,
    };
};

export default useIntentManagementApprovedAction;
